import { render, staticRenderFns } from "./integrations-tab.vue?vue&type=template&id=7d1d4930"
import script from "./integrations-tab.vue?vue&type=script&lang=js"
export * from "./integrations-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports